export default __webpack_public_path__ + "static/media/img2.884169ed.jpg";